import { render, staticRenderFns } from "./TickerMatch.vue?vue&type=template&id=c1d16238&scoped=true&lang=pug"
import script from "./TickerMatch.vue?vue&type=script&lang=js"
export * from "./TickerMatch.vue?vue&type=script&lang=js"
import style0 from "./TickerMatch.vue?vue&type=style&index=0&id=c1d16238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d16238",
  null
  
)

export default component.exports